<script setup>
import {useI18n} from 'vue-i18n';
import {useBookingStore} from "../../../Registration/stores/bookingStore";
import CompanionForm from "../../../Registration/components/Companions/CompanionForm.vue";
import {useSettingsManager} from "../../../Registration/stores/settingsManagerStore";
import {computed} from "vue";
import {useStepManager} from "../../../Registration/stores/stepsManager";

const { t } = useI18n();
const booking = useBookingStore();
const settingsManager = useSettingsManager();
const stepsManager = useStepManager();
const settings = settingsManager.settings;
const companionsEnabled = settings.withCompanions;
const eventMaxCompanions = settings.companionsLimit;
const guestPersonalLimit = booking.data.max_companion_limit ?? null;
const canAddCompanions = computed(()=>{
  if(guestPersonalLimit === null){
    return booking.data.companions.length < eventMaxCompanions;
  }
  return booking.data.companions.length < guestPersonalLimit;
});
const canShowCompanionsForm = computed(()=>{
    if(stepsManager.steps.length > 1){
        return stepsManager.current.include_companions;
    }
    return true;
})
</script>

<template>
    <div v-if="companionsEnabled && canShowCompanionsForm" class="py-4 registration-companions">
        <h4 class="companion-section-headline" v-text="t('registration.companions.headline')"></h4>
        <div class="my-4" role="list" :aria-labelledby="'companions-section-title'">
            <div class="w-full relative companion-form-wrapper border rounded-md p-4 mb-4"
                 v-for="(companion, index) in booking.data.companions"
                 :key="`companion-form-wrapper-${companion.uniqueId}`"
                 role="group"
                 :aria-label="t('registration.companions.companion-item.headline', { num: index + 1 })">
                <a
                    href="#"
                    role="button"
                    tabindex="0"
                    class="p-2 absolute right-2 top-2 text-red-600 hover:underline registration-companion-remove-btn"
                    :aria-label="t('registration.companions.remove-button-aria')"
                    @click.prevent="booking.removeCompanion(companion.uniqueId)"
                    @keydown.enter.prevent="booking.removeCompanion(companion.uniqueId)"
                    @keydown.space.prevent="booking.removeCompanion(companion.uniqueId)"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </a>
                <h5 class="companion-headline-count" v-text="t('registration.companions.companion-item.headline',{ num: index + 1})"></h5>
                <div class="registration-fields-wrapper grid grid-cols-1 form-fields-grid md:grid-cols-12">
                    <CompanionForm :id="companion.uniqueId" />
                </div>
            </div>

        </div>
        <a v-if="canAddCompanions"  role="button" @click="booking.addCompanions" class="btn btn-action flex! items-center" style="width: max-content;" >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            <span class="ml-1">{{t('registration.companions.add-companion-button-text')}}</span>
        </a>
    </div>
</template>

<style scoped>

</style>
